import { defineStore } from "pinia";
import { ref } from "vue";
import { api } from "../api";

interface Profile {
    id: string;
    name: string;
    kind: "dev" | "admin" | "agency" | "user_att";
    email: string | undefined;
    avatar: string | undefined;
    username: string;
    privileges: Set<string>;
}

export const useProfileStore = defineStore("profile", () => {
    const data = ref<Profile>();

    async function synchronize() {
        const profileResult = await api.user.profile().execute();

        if (profileResult === undefined) throw new Error("Failed to synchronize profile data");

        data.value = {
            id: profileResult.id,
            name: profileResult.name,
            kind: profileResult.kind,
            email: profileResult.email,
            avatar: profileResult.avatar,
            username: profileResult.username,
            privileges: new Set(["*", ...profileResult.privileges]),
        };
    }

    return { data, synchronize };
});
